let idCounter = 0;

export function id(): number {
  return idCounter++;
}
